import firebase from "../../firebase"

const db = firebase.firestore().collection("/static")

export default {
    get() {
        return db;
    }
}